
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProductService } from 'src/app/services/products.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { VolumetricValidation, regexPattern } from 'src/app/models/validator';
import { AppCoreService } from 'src/app/services/app-core.service';
import * as $ from 'jquery';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Title } from '@angular/platform-browser';
import { Utilities } from 'src/app/models/utilities';

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})
export class AddProductComponent implements OnInit, AfterViewInit {
  productForm: FormGroup;
  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };
  isFormSubmitted = false;
  productTypeList: any[] = [];
  applicableChargeList: any[] = [];
  centimeterList = [5000, 6000, 27000];
  inchesList = [2000, 4000];
  useEnterKey: any;
  constructor(
    private formBuilder: FormBuilder,
    private appCoreService: AppCoreService,
    private productService: ProductService,
    private router: Router,
    private ngxLoaderService: NgxUiLoaderService,
    private titleService: Title,
    private utilities: Utilities,
  ) {
    titleService.setTitle('Products');
  }

  ngOnInit() {
    this.productTypeList = ['Domestic', 'International', 'Import'];
    this.applicableChargeList = ['Fuel Charge'];
    this.productForm = this.formBuilder.group({
      txtCode: [null, Validators.compose([Validators.required, Validators.maxLength(5)])],
      txtName: [null, Validators.compose([Validators.required, Validators.maxLength(50)])],
      ddlProductType: [null, Validators.compose([Validators.required])],
      ddlApplicableCharge: [null],
      shipmentType: ['DOX'],
      status: ['true']
    });

    this.handelEvent(null);
    const firstInput = $(':input').first();
    if (firstInput) {
      firstInput.focus();
    }

    this.checkPermission();
    this.bindProducts();
  }

  ngAfterViewInit(): void {
    this.useEnterKey ? this.utilities.focusFirstElement(this.productForm) : null;
  }

  checkPermission(): any {
    const userData = this.appCoreService.GetUserData();
    this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
    const permission = userData.config.filter(x => x.categoryname === 'Products');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }

  addProduct() {
    try {
      if (!this.permConfig.isAddAllowed) {
        this.warningDialog('No access to Add.');
        return;
      }
      this.isFormSubmitted = true;
      if (this.permConfig.isAddAllowed && this.productForm.valid) {
        const requestObj = {
          code: this.productForm.get('txtCode').value.toUpperCase(),
          name: this.productForm.get('txtName').value,
          producttype: this.productForm.get('ddlProductType').value,
          applicablecharge: this.productForm.get('ddlApplicableCharge').value,
          shipmenttype: this.productForm.get('shipmentType').value,
          status: this.productForm.get('status').value
        }
        this.ngxLoaderService.start();
        this.productService.Add(requestObj).subscribe((res) => {
          if (res?.success) {
            this.ngxLoaderService.stop();
            this.openConfirmationDialog("Record Added Successfully");
          } else if (res && !res.success) {
            this.ngxLoaderService.stop();
            this.appCoreService.showMessage(res.data.err_msg, "Error", 'error')
          }
        })
      }
    }
    catch (err) {
      console.error(err);
    }
  }

  handelEvent(e: KeyboardEvent) {
    $(document).ready(function () {

      var inputs = $(':input').keydown(function (e) {
        if (e.key == 'Enter') {
          e.preventDefault();
          var nextInput = inputs.get(inputs.index(this) + 1);
          if (nextInput) {
            nextInput.focus();
          }
        }
      });

    });
  }

  resetForm() {
    this.isFormSubmitted = false;
    this.productForm.reset();
  }

  bindProducts() {
    try {
      const metaInfo = this.appCoreService.GetUserData()?.metaInfo;
      if (metaInfo.operationtype.includes('Domestic') && metaInfo.operationtype.includes('International')) {
        this.productTypeList = ['Domestic', 'International', 'Import'];
      } else if (metaInfo.operationtype.includes('Domestic')) {
        this.productTypeList = ['Domestic'];
        this.productForm.get('ddlProductType').setValue(this.productTypeList[0]);
      } else if (metaInfo.operationtype.includes('International')) {
        this.productTypeList = ['International', 'Import'];
      } else {
        this.productTypeList = [''];
      }
    } catch (e) {
      console.error(e);
    }
  }

  async openConfirmationDialog(msg: any) {
    const res = await Swal.fire({
      // title: 'Success',
      text: msg,
      icon: 'success',
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowOutsideClick: false
    })
    if (res.isConfirmed) {
      this.router.navigate(['/setup/products'])
    }
  }

  warningDialog(msg: any) {
    Swal.fire({
      title: 'Warning!',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
  }
}

